import { render, staticRenderFns } from "./OthersForm.vue?vue&type=template&id=8b2c57c2&scoped=true&"
import script from "./OthersForm.vue?vue&type=script&lang=js&"
export * from "./OthersForm.vue?vue&type=script&lang=js&"
import style0 from "./OthersForm.vue?vue&type=style&index=0&id=8b2c57c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c57c2",
  null
  
)

export default component.exports